import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  toggle: {
    '& .MuiTypography-root': {
      color: theme.palette.common.black,
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
    },
  },
}))
